import styled from "styled-components/native";
import { Link } from "@react-navigation/native";
import Theme from "../../theme";

export default styled(Link)`
  color: ${Theme.colors.blue};
`;
